/* eslint max-classes-per-file: 0 */

import {
  LkPassport as Data,
  LkPassportCollection as Collection,
} from '@/typings/api/Passport'

import { BaseApiParams } from '@/typings/common'
import { LKPassportsAdapter } from '@/views/LKPassport/store/LKPassportAdapter'
import { Fabric } from '@/store/createCrudModule'

export const fabric = Fabric<Data, Collection>()

type S = LKPassportState
type G = LKPassportGetters
type M = LKPassportMutations
type A = LKPassportActions


export class LKPassportState extends fabric.State {
  public filters: BaseApiParams = {
    is_filter: true,
    is_active: true,
  };
}

export class LKPassportGetters extends fabric.Getters<S> {
}

export class LKPassportMutations extends fabric.Mutations<S> {
}

export class LKPassportActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new LKPassportsAdapter();

  protected readonly idName = 'id';
}
